module.exports = __webpack_public_path__ + "static/media/legends-never-die.5490d902.mp3";